import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card ,Switch   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import Modaladdcurriculumopen from './Modaladdcurriculumopen';
import Modeltest from './Modeltest';
import Modaladdteacher from './Modaladdteacher';

import Swal from 'sweetalert2/dist/sweetalert2.js'
import ModalEditcurriculumopen from './ModalEditcurriculumopen';
import { api, URL } from '../../api';
import ModalReportstudent from './ModalReportstudent';
import ModalAddstudentforadmin from './ModalAddstudentforadmin';
var md5 = require('md5');




export default class Addstudentfromtabian extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
          switch1:true,
         
          type:'1',
        
          year:'2564',
          search: '',

          Course: [],
          Courseselect: [],
          Curriculumopen:[],
          Coursesearch: [],

        
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },


          Studentcb:'',
          studenttabian:[],

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

      
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.onChangeswit = this.onChangeswit.bind(this);
        this.getsearch = this.getsearch.bind(this);
        this.getsearc2 = this.getsearc2.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.getstudentfromtabian = this.getstudentfromtabian.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }



        onChangeswit(checked,event) {

      //  console.log(`switch to ${checked}`);
      //  console.log(`switch to ${event.target.value}`);
   
        const datafrm = new FormData(); 

        if (checked === true) {
          datafrm.append("Curriculumopen_Status_ONOFF", '1') ;
        }else{
          datafrm.append("Curriculumopen_Status_ONOFF", '0') ;
        }
        datafrm.append("Curriculumopen_ID", event.target.value);
      
       // console.log(datafrm);
       api.post("index/updateCurriculumonoff/",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {
              if (checked === true) {
                 Swal.fire({
                      title: 'เปิดหลักสูตรสำเร็จ',
                      icon: 'success',
                     // text: 'กรุณาลองอีกครั้ง',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
              } else {
                Swal.fire({
                  title: 'ปิดหลักสูตรสำเร็จ',
                  icon: 'success',
                 // text: 'กรุณาลองอีกครั้ง',
                // showCancelButton: true,
                  confirmButtonText: 'ตกลง',
                // cancelButtonText: 'No, keep it'
                }).then((result) => {
                
                })
                
              }   
        }) 
       }


        //ค้นหาหลักสูตรที่เปิดสอน
        getsearch(value) {
          setTimeout(() => {
           console.log(value)
            const Course = this.state.Course.filter( ({ Curriculumopen_TEAM }) => Curriculumopen_TEAM === value );
            this.setState({ Course });
           }, 0);
        }


           getsearc2(value) {
          setTimeout(() => {
           console.log(value)
            const Course = this.state.Course.filter( ({ Curriculumopen_Approve_Dean }) => Curriculumopen_Approve_Dean === value );
            this.setState({ Course });
           }, 0);
        }

          getstudentfromtabian() {
                            setTimeout(() => {
                               //ภายใน
                               api.get('index/getstudentall/'+this.state.Studentcb)
                               .then(res => {
                                 console.log(res.data);
                               //  this.setState({ bankname: res.data, loading: false })
                                 const    parts = res.data[0].NAME.split(" ");
                                 console.log( parts[0]);

                                 this.setState({ studenttabian: res.data})
                               }) 
                             }, 0);
                        }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });


           this.getCurriculumopen()

        }


         onTextChange = (e) => {
                this.setState({ [e.target.name]: e.target.value })
              }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
               console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
      }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 

         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }




          componentDidMount(){
           

            if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
            api.get('index/gettcurriculummooc/'+localStorage.getItem('Univ_ID'),
                      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                       //  console.log(res.data)
                        // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                       //  console.log(Course)
                          const Course = res.data;
                          this.setState({ Course });
                          const Coursesearch = res.data;
                          this.setState({ Coursesearch });

                         
                      })         
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };




       handleSubmit() {
          // alert('A name was submitted: ' + this.state.value);
                
           for (let index = 0; index < this.state.studenttabian.length; index++) {

                         const    parts = this.state.studenttabian[index].NAME.split("  ");


                                     const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                       datafrm.append("Studentcb_Citizen_ID", this.state.studenttabian[index].GDNAME);
                                       datafrm.append("Studentcb_PNAME", this.state.studenttabian[index].PNAME);
                                       datafrm.append("Studentcb_NAME", parts[0]);
                                       datafrm.append("Studentcb_LASTNAME", parts[1]);
                                       datafrm.append("Studentcb_DB", this.state.studenttabian[index].BDATE);
                                       datafrm.append("Studentcb_PASSWORD", this.state.studenttabian[index].BDATE);
                                       datafrm.append("Studentcb_DBMD5", md5(this.state.studenttabian[index].BDATE));
                                       datafrm.append("Studentcb_ADDRESS", this.state.studenttabian[index].ADD1);
                                       datafrm.append("Studentcb_PROVINCE", '62');
                                       datafrm.append("Studentcb_DISTRICT", '6201');
                                       datafrm.append("Studentcb_SUBDISTRICT", '620105');
                                       datafrm.append("Studentcb_ZIPCODE", '62000');
                                       datafrm.append("Studentcb_TEL", '-');
                                       datafrm.append("Studentcb_EMAIL", '-');
                                       datafrm.append("Studentcb_Education_LEVEL", '4');
                                       datafrm.append("Studentcb_SCHOOL", 'มหาวิทยาลัยราชภัฏกำแพงเพชร');
                                       datafrm.append("Studentcb_ID_NO", this.state.studenttabian[index].OLDID);
                                       datafrm.append("Studentcb_TYPE", '1');
            
            Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddStudentRegister/",datafrm,{
                  headers: {
                      'content-type': 'multipart/form-data'
                  }
             })
      
            .then(res => {
            //    console.log(res);
              if (this.state.studenttabian.length === index+1) {
              //  alert("บันทึกสำเร็จ")
                        Swal.fire({
                            title: 'ลงทะเบียนสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                          
                          })
                       }
              })


        } //ปิดloop
      

       
        }



       


    render() {

     //   console.log(this.state.Course_ID)
        let { sortedInfo, filteredInfo } = this.state;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
        const {  pagination } = this.state;
     
   
        const { Option } = Select;



               //ชุดตาราง
               const data = {
                columns: [
                  {
                    label: '#',
                    field: 'list',
                    sort: 'list',
                    width: 150
                  },
                  {
                    label: 'ปี',
                    field: 'Course_YEAR',
                    sort: 'Course_YEAR',
                    width: 150
                  },
                  {
                    label: 'คำนำหน้า',
                    field: 'Curriculumopen_TEAM',
                    sort: 'Curriculumopen_TEAM',
                    width: 270
                  },
                  {
                    label: 'ชื่อ-สกุล',
                    field: 'Curriculumopen_Full_Name_TH',
                    sort: 'Curriculumopen_Full_Name_TH',
                    width: 200
                  },
                  {
                    label: 'วันเดือนทีเกิด',
                    field: 'Curriculumopen_Full_Name_EN',
                    sort: 'Curriculumopen_Full_Name_EN',
                    width: 100
                  },
                 


                ],
      
                rows: [...this.state.studenttabian.map((data, i) => (

             
                  {
                       
                     list: <>{i+1}</>,
                     Course_YEAR: <>{data.OLDID}</>,
                     Curriculumopen_TEAM: <>{data.PNAME}</>,
                     Curriculumopen_Full_Name_TH: <>{data.NAME}</>,
                     Curriculumopen_Full_Name_EN: <>{data.BDATE}</>,
                   



                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                    
     
                  }
                 ))]
                
            
            };
      
            const persons = <MDBDataTable
           // searching ={true}
            searchLabel="ค้นหา ชื่อหลักสูตร"
            striped
            bordered
            small 
            entries={20}
           // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={data}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            />
      //ชุดตาราง




       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
{/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> เพิ่มข้อมูลนักศึกษา</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >

       <MDBRow>
          
              <MDBCol sm="4">
          
          <div className="form-group">
                           <label htmlFor="example2">หมู่เรียน</label>
                           <Input placeholder="หมู่เรียน" value={this.state.Studentcb} name="Studentcb" onChange={this.onTextChange} required  />                                
                       </div>
                        <MDBBtn onClick={this.getstudentfromtabian} color="primary" size='sm' >ค้นหา</MDBBtn>  
            </MDBCol>

            <MDBCol sm="4">
              
            </MDBCol> 
  </MDBRow>

<br/>
   

     <MDBRow>
          <MDBCol sm="12">
         
                      <MDBJumbotron fluid>
                        <MDBContainer fluid>
                        <h2 className="display-5 deep-purple-text text-center">ข้อมูลนักศึกษา MOOC</h2>
                           
                        <h3>จำนวน {this.state.studenttabian.length} คน</h3>
                            {persons} 
   <p className="text-center"><MDBBtn color="secondary" onClick={this.handleSubmit} >ลงทะเบียน</MDBBtn></p>
                        </MDBContainer>
                        </MDBJumbotron>
                       
          </MDBCol>
     </MDBRow>

        </Card>

       
            </MDBContainer>
        )
    }
}
